import { render, staticRenderFns } from "./multitext.vue?vue&type=template&id=5775a26c&scoped=true&"
import script from "./multitext.vue?vue&type=script&lang=js&"
export * from "./multitext.vue?vue&type=script&lang=js&"
import style0 from "./multitext.vue?vue&type=style&index=0&id=5775a26c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5775a26c",
  null
  
)

export default component.exports